<template>
  <!--
   debitis-blanditiis-et-cupiditate-et-iure-veniam-esse
   تست-محصول-متغییر
   محصول-دو-متغیره
   -->
  <b-container>
    <m-single-product-wrapper :product-link="productLink" @product="dataReady">
      <template slot-scope="{product}">
        <div>
          <b-container fluid>
            <b-col lg="12">
              <m-a :href="{name:'SingleProduct',params:{name:product.raw_link}}">
                <span class="text-dark breadcrumb-item-size"> خانه </span>
              </m-a>
              /
              <m-a :href="{name:'Products'}">
                <span class="text-dark breadcrumb-item-size"> محصولات </span>
              </m-a>

              <div class="d-inline" v-if="product.brand">
                /
                <m-a :href="{name:'Products',query: { page: 1, brand: product.brand.id }}">
                  <span class="text-dark breadcrumb-item-size"> {{ product.brand.name }} </span>
                </m-a>
              </div>

            </b-col>
          </b-container>

          <b-container fluid>
            <b-row class="m-3">

              <b-col lg="4" md="4" sm="12">

                <swiper :options="swiperOptions" class="gallery-top" ref="swiperTop">
                  <swiper-slide>
                    <b-img
                        class="pr-2 img-slider"
                        :src="product.thumbnail"
                        :alt="product.name"
                    />
                  </swiper-slide>
                  <template v-if="product.images && product.images.length > 0">
                    <swiper-slide v-for="img in product.images" :key="img.id">
                      <b-img
                          class="pr-2 img-slider"
                          :src="img.file"
                          :alt="product.name"
                      />
                    </swiper-slide>
                  </template>
                  <div
                      class="swiper-pagination swiper-pagination-bullets"
                      slot="pagination"
                  ></div>
                </swiper>
                <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                  <swiper-slide>
                    <b-img
                        class="pr-2 img-slider"
                        :src="product.thumbnail"
                        :alt="product.name"
                    />
                  </swiper-slide>
                  <template v-if="product.images && product.images.length > 0">
                    <swiper-slide v-for="img in product.images" :key="img.id">
                      <b-img
                          class="pr-2 img-slider"
                          :src="img.file"
                          :alt="product.name"
                      />
                    </swiper-slide>
                  </template>
                  <div class="swiper-button-next" slot="button-next"></div>

                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div
                      class="swiper-pagination swiper-pagination-bullets"
                      slot="pagination"
                  ></div>
                </swiper>

              </b-col>

              <b-col lg="5" md="5" sm="12">

                <div class="d-inline category-item" v-for="(category,index) in product.category">
                  <m-a :href="{name:'SingleCategory',params:{slug:category.slug}}">
                    <span class="text-dark"> {{ category.name }} </span>
                  </m-a>
                  <span v-if="index < product.category.length-1 ">/</span>
                </div>


                <div class="pt-4">


                  <h1 class="product-name text-dark font-weight-bold ">{{ product.name }}</h1>


                  <!--                  <div class="">

                                      <span class="text-dark  d-inline-block  mt-5 ">
                                        <b-icon icon="star-fill" class="star-size"></b-icon>

                                        <span class="font-weight-bolder">4.4</span>



                                        <span class="text-muted"> (742) </span>

                                      </span>


                                      <span class="  font-weight-lighter">
                                          <b-icon icon="record-fill" class="feature-attribute-image mr-2"></b-icon>
                                      </span>


                                      <span class="comments-counter mr-2 font-weight-bold">637 دیدگاه کاربران</span>
                                    </div>-->


                </div>
                <!--                <p class="font-weight-bold pt-4">
                                  رنگ : آبی
                                </p>


                                <div>
                                  <div class="circle mx-1 blue">

                                  </div>
                                  <div class="circle mx-1 bg-white">

                                  </div>
                                  <div class="circle mx-1 pink">

                                  </div>
                                </div>-->


              </b-col>

              <m-single-product-price-wrapper :digital-shopping-cart-text="digitalShoppingCartText"
                                              :physical-shopping-cart-text="physicalShoppingCartText"
                                              :product="product">
                <template v-slot="{timing,quantity,addToCartFunction,buttonText}">

                  <b-col class="text-center " lg="3" md="3" sm="12">
                    <div class="row box align-items-center ">


                      <div class="col-lg-12" v-if="timing">
                        <div class="col-lg-12" v-if="quantity">
                          <m-single-product-price-1
                              :buttonText="buttonText"
                              :addToCartFunction="addToCartFunction"
                              :product="product"
                          />
                        </div>

                        <div class="w-100" v-else>
                          <span class="text-center">موجودی محصول به پایان رسیده است.</span>
                        </div>


                      </div>
                      <div class="w-100" v-else>
                        <span class="text-center ">زمان سفارش این محصول به پایان رسیده است.</span>
                      </div>

                    </div>
                  </b-col>


                </template>
              </m-single-product-price-wrapper>

            </b-row>
          </b-container>

          <b-container>
            <b-row class="mt-3">
              <b-tabs class="customize-tab-colors col-lg-12" content-class="border" justified>
                <b-tab active title="مشخصات محصول">
                  <div>
                    <b-table
                        class="text-right"
                        v-bind="tableAttributes"
                        :fields="fields"
                        :items="tableFeature(product.features)"
                    >
                      <template #cell(name)="data">
                        <span>{{ data.item.text }}</span>
                      </template>
                      <template #cell(feature_value)="data">
                        {{ data.item.value }}
                      </template>
                    </b-table>
                  </div>
                </b-tab>
                <b-tab class="p-4" title="شرح محصول" v-html="processContent(product.description)">
                </b-tab>
              </b-tabs>
            </b-row>
          </b-container>

          <b-container class="my-5" v-if="relatedProducts">

            <h3 class="">{{ relatedProductsText }}</h3>

            <m-related-products-300
                :related-product-price="relatedProductPrice"
                :ignore-product="[product.id]"
                :product-brands="[product.brand.slug]"
                :product-categories="productCategories(product)"
            />

          </b-container>


        </div>
      </template>
    </m-single-product-wrapper>


  </b-container>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import TableLayout from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/dashboard/TableLayout";

export default {
  name: "SingleProduct600",
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      default: false
    },
    digitalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
    physicalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
    relatedProductsText: {
      default: "محصولات مرتبط"
    },
    relatedProductPrice: {
      default: true
    },
  },
  components: {TableLayout, Swiper, SwiperSlide,},
  data() {
    return {
      tableAttributes: {
        ...tableAttributes,
        ...{class: "text-right", fixed: true},
      },
      fields: [
        {key: "name", label: ""},
        {key: "feature_value", label: ""},
      ],
      swiperOptions: {
        slidesPerView: 1,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },

      },
      swiperOptionThumbs: {
        notNextTick: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    tableFeature(product_features) {
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product

        if (feature.feature_values.sub_product == 0 && feature.feature_values.variation == 0) {
          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          if (feature.type == 'text') {
            product_variation.push({text: feature.name, value: feature.feature_values.feature_value})
          }

          if (feature.type == 'list') {
            feature_attributes.forEach(item => {
              if (item.id == feature_attribute_id) {
                product_variation.push({...item, text: feature.name, value: item.value})
              }
            })

          }


        }

      }

      return product_variation
    },
    dataReady(product) {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    productCategories(product) {
      return product.category.map(item => {
        return item.slug;
      })
    }
  },
};
</script>


<style scoped>
.circle {
  border-radius: 50%;
  width: 20px;
  padding: 15px;
  cursor: pointer;
  border: 1px solid #888;
  display: inline-block;
}


.blue {
  background-color: blue;
}

.pink {
  background-color: palevioletred;
}

.box {
  background-color: #e5eaec;
  border-radius: 20px;
  height: 350px;
}

.product-name {
  font-size: 20px;
}

.star-size {
  font-size: 15px;
  color: #f89b64;
}

.feature-attribute-image {
  font-size: 9px;
  color: #a19d9d;

}

.comments-counter {
  color: #a2a4e3;
  font-size: 12px;
}

.breadcrumb-item-size {
  font-size: 14px;
  color: #19bfd3 !important;
}

.category-item * {
  color: #19bfd3 !important;
}

.img-slider {
  width: 100%;
  object-fit: contain;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  background: white;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

</style>